const defaultSort = 'name';

const initialState = {
  records: [],
  sortTerm: defaultSort,
  sortInverse: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'LOAD_AGENCIES': {
      const agencies = action.payload.map((agency) => ({
        ...agency,
        visible: true,
      }));
      return { ...state, records: agencies };
    }
    case 'FILTER_AGENCIES': {
      const term = action.term.toLowerCase();
      const records = state.records.map((agency) => {
        const matches = Object.values(agency).filter((data) => {
          if (data && data.includes) {
            return data.toLowerCase().includes(term);
          }
          return false;
        });
        return { ...agency, visible: matches.length > 0 };
      });
      return { ...state, records };
    }
    case 'CLEAR':
      return { ...initialState };
    case 'SET_AGENCIES_SORT_TERM':
      /* eslint-disable no-case-declarations */
      const newSortTerm = action.payload ? action.payload : defaultSort;
      return { ...state, sortTerm: newSortTerm };
      /* eslint-enable no-case-declarations */
    case 'CLEAR_AGENCIES_SORT_TERM':
      return { ...state, sortTerm: defaultSort };
    case 'SET_AGENCIES_SORT_INVERSE':
      return { ...state, sortInverse: action.payload };
    case 'CLEAR_AGENCIES_SORT_INVERSE':
      return { ...state, sortInverse: false };
    default:
      return state;
  }
};
